import { Transition } from '@/core/Transition.js'
import { App } from '@/core/App.js'
import { Nav } from '@/core/Nav'
import { processUrl } from '@/utils/Url.js'
import { Sleep } from '@/utils/Sleep.js'

export class DefaultTransition extends Transition {
  async onLeave({ from, trigger, done }) {
    if (Nav.menuOpen) Nav.toggleMenu(false)
    await App.pageOverlay.show()
    if (Nav.navSearch) Nav.navSearch.hideModal(true)
    done()
  }

  async onEnter({ to, trigger, done }) {
    Nav.clear()
    document.body.classList.remove('is-scrolling')

    const currentLocation = processUrl(trigger.href)

    if (currentLocation.hasHash) {
      await Sleep(500)
    } else {
      await App.pageOverlay.hide()
    }

    done()
  }
}
